import * as React from 'react';
import { styled } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PaymentIcon from '@mui/icons-material/Payment';
import LogoutIcon from '@mui/icons-material/Logout';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser } from '../../store/loginUserSlice';

const ListLink = styled(Link)(({ theme }) => ({
  color: theme.palette.action.active,
  textDecoration: 'none',
  fontSize: 20,
  ':hover': {
    color: 'red',
  },
}));

function MainListItems() {
  const dispatch = useDispatch();
  const logout = () => {
    dispatch(setUser(''));
  };

  return (
    <React.Fragment>
      <ListLink to='/'>
        <ListItemButton>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary='ダッシュボード' />
        </ListItemButton>
      </ListLink>
      <ListLink to='/incomings'>
        <ListItemButton>
          <ListItemIcon>
            <AllInboxIcon />
          </ListItemIcon>
          <ListItemText primary='受信ボックス' />
        </ListItemButton>
      </ListLink>
      <ListLink to='/incoming-setting'>
        <ListItemButton>
          <ListItemIcon>
            <RecordVoiceOverIcon />
          </ListItemIcon>
          <ListItemText primary='着信設定' />
        </ListItemButton>
      </ListLink>
      <ListLink to='/payments'>
        <ListItemButton>
          <ListItemIcon>
            <PaymentIcon />
          </ListItemIcon>
          <ListItemText primary='支払情報' />
        </ListItemButton>
      </ListLink>
      <ListLink to='/account'>
        <ListItemButton>
          <ListItemIcon>
            <ManageAccountsIcon />
          </ListItemIcon>
          <ListItemText primary='アカウント設定' />
        </ListItemButton>
      </ListLink>
      <ListLink to='/'>
        <ListItemButton onClick={logout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary='ログアウト' />
        </ListItemButton>
      </ListLink>
    </React.Fragment>
  );
}

export default MainListItems;
